














































import Vue from 'vue';
import Curve1 from '@/assets/img/shapes/curves/curve-1.svg';
import HandlebarIcon from '@/assets/img/icons/handle.svg';
import { SparkelloImageUtil, WebDream } from '@/web';

export default Vue.component('DreamListItem', {
  components: {
    Curve1,
    HandlebarIcon,
  },
  props: {
    dream: WebDream,
    editMode: Boolean,
    touchScreen: Boolean,
  },
  data() {
    return {
      dreamImgUri: '',
    };
  },
  methods: {
    edit(id: string) {
      console.log('Edit id ', id);
    },
    imageClass(): string {
      return this.editMode ? 'dream-cover-image-edit card-img' : 'dream-cover-image card-img-top';
    },
    cardClass(): string {
      //If we are not operating on a touch screen then apply the handle class to the entire card
      //This means that a click and drag on any part of the card will allow a move.
      const handleClass = !this.touchScreen ? ' handle' : '';

      return this.editMode ? ' dream-cover-image-edit bg-cover overlay overlay-black overlay-40' + handleClass : ' shadow-light lift lift-lg';
    },
    cardStyle(dream: WebDream): string {
      return this.editMode ? 'background-image: url(' + (this.$data.dreamImgUri || '') + ');' : '';
    },
  },
  created() {
    SparkelloImageUtil.instance.getRegularImageSource(this.$props.dream?.image).then(uri => {
      this.$data.dreamImgUri = uri;
      console.log(uri);
      this.$forceUpdate();
    });
  },
  watch: {
    dream: function (newVal, oldVal) { // watch it
      if (newVal?.image && newVal?.image != oldVal?.image) {
          SparkelloImageUtil.instance.getRegularImageSource(newVal.image).then(uri => {
            this.$data.dreamImgUri = uri;
            console.log(uri);
            this.$forceUpdate();
          });
      }
    },
  },
})
;
